class SubcontractProjectViewController {
  constructor() {
    'ngInject';
  }
}

export default SubcontractProjectViewController;



// WEBPACK FOOTER //
// ./client/pages/admin/project-details/views/subcontract-project-view/subcontract-project-view.controller.js